var exports = {
  "K": "xcc377c0b--05c840--icon",
};

module.exports = exports;
